import React, { MouseEventHandler, useMemo } from 'react';
import Select, {
  components,
  DropdownIndicatorProps,
  IndicatorSeparatorProps,
  OnChangeValue,
  ActionMeta,
  MultiValueGenericProps,
  MultiValueProps,
  Props,
  PropsValue,
  GroupBase,
} from 'react-select';
import { SelectorIcon } from '@heroicons/react/solid';
import { DefaultInputTypes } from './Types';
import InputLabel from './InputLabel';
// import {
//   SortableContainer,
//   SortableContainerProps,
//   SortableElement,
//   SortEndHandler,
//   SortableHandle,
// } from 'react-sortable-hoc';
import { useCommonSelector } from '@wajeez-web/stores/common';

function arrayMove<T>(array: readonly T[], from: number, to: number) {
  const slicedArray = array.slice();
  slicedArray.splice(
    to < 0 ? array.length + to : to,
    0,
    slicedArray.splice(from, 1)[0]
  );
  return slicedArray;
}

// const SortableMultiValue = SortableElement((props: MultiValueProps<Option>) => {
//   // this prevents the menu from being opened/closed when the user clicks
//   // on a value to begin dragging it. ideally, detecting a click (instead of
//   // a drag) would still focus the control and toggle the menu, but that
//   // requires some magic with refs that are out of scope for this example
//   const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//   };
//   const innerProps = { ...props.innerProps, onMouseDown };
//   return <components.MultiValue {...props} innerProps={innerProps} />;
// });

// const SortableMultiValueLabel = SortableHandle(
//   (props: MultiValueGenericProps) => <components.MultiValueLabel {...props} />
// );

const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  backgroundColor: 'white',
  marginBottom: 8,
  marginTop: 8,
  width: 1,
};

export interface SortableInputSelectProps<TOption> extends DefaultInputTypes {
  options: TOption[];
  showSwelectIndecator?: boolean;
  inputValue?: string;
  value?: PropsValue<TOption> | undefined;
  isMulti?: boolean | undefined;
  onChange: (name: string, value: PropsValue<TOption> | undefined) => void;
  isMenuOpen?: boolean;
  onSearch?: (search: string) => void;
}

function SortableInputSelect<TOption>({
  placeholder = 'Select...',
  name,
  value,
  isMulti = undefined,
  options,
  showSwelectIndecator = true,
  onChange,
  label,
  required = false,
  isMenuOpen,
  onSearch,
}: SortableInputSelectProps<TOption>) {
  return null;
  // const { dir } = useCommonSelector((state) => state.common.settings);

  // const handleChange = (
  //   value: OnChangeValue<TOption, true>,
  //   actionMeta: ActionMeta<TOption>
  // ) => {
  //   onChange(name, value);
  // };
  // const onSortEnd: SortEndHandler = ({ oldIndex, newIndex }) => {
  //   const newValue = arrayMove(
  //     Array.isArray(value) ? value : [],
  //     oldIndex,
  //     newIndex
  //   );
  //   onChange(name, newValue);
  // };

  // const SortableSelect = useMemo(
  //   () =>
  //     SortableContainer(Select) as React.ComponentClass<
  //       Props<TOption, true> & SortableContainerProps
  //     >,
  //   []
  // );

  // const DropdownIndicator = useMemo(
  //   () => (props: DropdownIndicatorProps<TOption, true>) => {
  //     return (
  //       <components.DropdownIndicator {...props}>
  //         <SelectorIcon className="h-5 w-5 text-gray-400" />
  //       </components.DropdownIndicator>
  //     );
  //   },
  //   []
  // );

  // const IndicatorSeparator = useMemo(
  //   () =>
  //     ({ innerProps }: IndicatorSeparatorProps<TOption, true>) => {
  //       return <span style={indicatorSeparatorStyle} {...innerProps} />;
  //     },
  //   []
  // );
  // return (
  //   <div>
  //     {label && <InputLabel text={label} name={name} required={required} />}
  //     <SortableSelect
  //       useDragHandle
  //       // react-sortable-hoc props:
  //       axis="xy"
  //       className="input"
  //       onSortEnd={onSortEnd}
  //       distance={4}
  //       // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
  //       getHelperDimensions={({ node }) => node.getBoundingClientRect()}
  //       // react-select props:
  //       isMulti
  //       options={options}
  //       value={value}
  //       onChange={handleChange}
  //       components={{
  //         MultiValue: SortableElement<
  //           MultiValueProps<TOption, true, GroupBase<TOption>>
  //         >((props: MultiValueProps<TOption, true, GroupBase<TOption>>) => {
  //           // this prevents the menu from being opened/closed when the user clicks
  //           // on a value to begin dragging it. ideally, detecting a click (instead of
  //           // a drag) would still focus the control and toggle the menu, but that
  //           // requires some magic with refs that are out of scope for this example
  //           const onMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
  //             e.preventDefault();
  //             e.stopPropagation();
  //           };
  //           const innerProps = { ...props.innerProps, onMouseDown };
  //           return <components.MultiValue {...props} innerProps={innerProps} />;
  //         }),
  //         MultiValueLabel: SortableMultiValueLabel as any,
  //         IndicatorSeparator,
  //         DropdownIndicator,
  //       }}
  //       closeMenuOnSelect={false}
  //       styles={{
  //         control: (base, state) => ({
  //           ...base,
  //           minHeight: '36px !important',
  //           // height: "36px !important",
  //           padding: '0px !important',
  //           textAlign: dir === 'ltr' ? 'left' : 'right',
  //           ' --tw-ring-opacity': 1,
  //           '--tw-ring-opacity': state.isFocused ? 0.1 : 'default',
  //           ' --tw-ring-color': state.isFocused
  //             ? 'var(--theme-ring-color)'
  //             : 'default',
  //           '--tw-ring-offset-shadow': state.isFocused
  //             ? 'var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)'
  //             : 'default',
  //           '--tw-ring-shadow': state.isFocused
  //             ? 'var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)'
  //             : 'default',
  //           boxShadow: state.isFocused
  //             ? ' var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)'
  //             : 'default',
  //         }),
  //         menu: (provided) => ({
  //           ...provided,
  //           position: 'absolute',
  //           textAlign: dir === 'ltr' ? 'left' : 'right',
  //           'z-index': '999999 !important',
  //         }),
  //         container: (base) => ({
  //           ...base,
  //           fontSize: '14px !important',
  //           padding: '0px !important',
  //           height: 'auto !important',
  //         }),
  //       }}
  //       theme={(theme) => ({
  //         ...theme,
  //         zIndex: 999,
  //         border: '0px none',
  //         width: '100%',
  //         borderRadius: 6,
  //         padding: 0,
  //         margin: 0,
  //         colors: {
  //           ...theme.colors,

  //           primary: 'var(--theme-primary)',
  //         },
  //       })}
  //     />
  //   </div>
  // );
}

export default SortableInputSelect;
